import { Navigate, useLocation } from "react-router-dom";

import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    // Use isAuthenticatedState (reactive) instead of isAuthenticated() (function)
    // This ensures component re-renders when auth state changes
    const { isAuthenticatedState } = FirebaseAuthContainer.useContainer();
    const location = useLocation();

    return isAuthenticatedState ? children : <Navigate to="/login" state={{ from: location }} />;
};

export default ProtectedRoute;
